// This file is used only for exposing a separate root export
module.exports = require('./lib/ThemeProvider');